module.exports = __webpack_public_path__ + "img/photo_230150655_1.6e7a84af.jpg";